import {
  Wrench, Shield, Clock, Car, Paintbrush, Award, Cog, ScanLine,
  Building2, CalendarCheck, Droplets, CircleGauge, Disc3, BatteryCharging,
  Phone, Mail, MapPin, MessageCircle, Star, Fuel, Truck, Settings2,
  Hammer, CircleDot, AlertTriangle, CheckCircle2, ThumbsUp, Heart,
  Zap, Target, Eye, FileText, CreditCard, BadgeCheck, ShieldCheck,
  Thermometer, Gauge, WrenchIcon, Pipette, Spray, PaintBucket,
  Boxes, Package, Warehouse, Tag, Banknote, HandCoins, Receipt,
  Navigation, Globe, ExternalLink, Home, Users, HelpCircle, Info,
  Scissors, Lightbulb, Timer, RotateCcw, RefreshCw, Search,
  Camera, Image as ImageLucide, ChevronRight
} from "lucide-react";

export const HERO_BG = "https://images.unsplash.com/photo-1763165562062-91d744691c65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjYXIlMjBzaG93cm9vbSUyMGludGVyaW9yJTIwZGFyayUyMHByZW1pdW18ZW58MHx8fHwxNzczMTQ1NjI5fDA&ixlib=rb-4.1.0&q=85";

export const ICON_MAP = {
  wrench: Wrench, cog: Cog, scan: ScanLine, shield: Shield,
  paintbrush: Paintbrush, award: Award, building: Building2, clock: Clock,
  calendar: CalendarCheck, car: Car, droplets: Droplets,
  gauge: CircleGauge, disc: Disc3, battery: BatteryCharging,
  phone: Phone, mail: Mail, mappin: MapPin, whatsapp: MessageCircle,
  star: Star, fuel: Fuel, truck: Truck, settings: Settings2,
  hammer: Hammer, wheel: CircleDot, alert: AlertTriangle,
  check: CheckCircle2, thumbsup: ThumbsUp, heart: Heart,
  zap: Zap, target: Target, eye: Eye, file: FileText,
  creditcard: CreditCard, badgecheck: BadgeCheck, shieldcheck: ShieldCheck,
  thermometer: Thermometer, speedometer: Gauge,
  pipette: Pipette, paint: PaintBucket,
  boxes: Boxes, package: Package, warehouse: Warehouse,
  tag: Tag, money: Banknote, finance: HandCoins, receipt: Receipt,
  navigation: Navigation, globe: Globe, external: ExternalLink,
  home: Home, users: Users, help: HelpCircle, info: Info,
  scissors: Scissors, lightbulb: Lightbulb, timer: Timer,
  rotate: RotateCcw, refresh: RefreshCw, search: Search,
  camera: Camera, image: ImageLucide,
};

export const ICON_CATEGORIES = {
  "Taller y mecanica": ["wrench", "cog", "hammer", "settings", "thermometer", "rotate", "refresh", "timer"],
  "Vehiculo": ["car", "truck", "fuel", "gauge", "speedometer", "disc", "wheel", "battery"],
  "Chapa y pintura": ["paintbrush", "paint", "pipette", "scissors", "droplets", "camera", "image"],
  "Recambios": ["package", "boxes", "warehouse", "tag", "search"],
  "Confianza": ["shield", "shieldcheck", "award", "badgecheck", "star", "check", "thumbsup", "heart"],
  "Diagnosis": ["scan", "eye", "lightbulb", "zap", "target", "alert"],
  "Citas y contacto": ["calendar", "phone", "mail", "whatsapp", "mappin", "navigation", "clock"],
  "Negocio": ["building", "money", "finance", "creditcard", "receipt", "file", "users", "info"],
  "General": ["home", "globe", "external", "help"],
};

export function getIcon(name) {
  return ICON_MAP[name?.toLowerCase()] || Wrench;
}

export function formatHours(wh) {
  if (!wh) return "";
  const parts = [];
  const weekdays = ["lunes", "martes", "miercoles", "jueves", "viernes"];
  const weekdayVals = weekdays.map(d => wh[d]).filter(Boolean);
  const uniqueWd = [...new Set(weekdayVals)];
  if (uniqueWd.length === 1 && uniqueWd[0] !== "cerrado") parts.push(`L-V ${uniqueWd[0].replace("-", "\u2013")}`);
  if (wh.sabado && wh.sabado !== "cerrado") parts.push(`S ${wh.sabado.replace("-", "\u2013")}`);
  return parts.join(" \u00b7 ") || "Consultar horario";
}

export function track(action, label) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "ascauto_cta", action, label });
  } catch {}
}
